import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__done",
  "use": "icon__done-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__done\"><title>Path</title><path d=\"M19.566 1.73L17.773.512a1.088 1.088 0 0 0-1.507.285l-8.79 12.96L3.439 9.72a1.085 1.085 0 0 0-1.532 0L.371 11.254a1.09 1.09 0 0 0 0 1.535L6.582 19c.348.348.895.613 1.387.613s.988-.308 1.308-.773L19.855 3.234a1.082 1.082 0 0 0-.289-1.504z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol